export default __webpack_public_path__ + "static/media/hand_tapped.b03fe30a.png";